import React from 'react';
import clsx from 'clsx';
import { AppBarProps, WithStyles } from '@material-ui/core';
import { withStyles, Theme } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import AppBar from '../components/AppBar';
import Toolbar, { styles as toolbarStyles } from '../components/Toolbar';

const styles = (theme: Theme) => ({
  title: {
    fontSize: 24,
    flexGrow: 1,
  },
  placeholder: toolbarStyles(theme).root,
  toolbar: {
    // justifyContent: 'space-between',
  },
  // left: {
  //   flex: 1,
  // },
  leftLinkActive: {
    color: theme.palette.common.white,
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  rightLink: {
    fontSize: 16,
    color: theme.palette.common.white,
    marginLeft: theme.spacing(3),
  },
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
});

function AppAppBar(props: WithStyles<typeof styles> & AppBarProps) {
  const { classes } = props;

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar className={classes.toolbar}>
          <Link
            variant="h6"
            underline="none"
            color="inherit"
            className={classes.title}
            href="https://github.com/Crowdaq/crowdaq-doc/blob/master/docs/requester/get-started.md"
            target="_blank"
          >
            {'crowdaq'}
          </Link>
          <div className={classes.right}>
            <Link
              color="inherit"
              variant="h6"
              underline="none"
              className={classes.rightLink}
              href="https://github.com/Crowdaq/crowdaq-doc/blob/master/docs/requester/get-started.md"
              target="_blank"
            >
              {'Get Started'}
            </Link>
            <Link
              variant="h6"
              underline="none"
              className={clsx(classes.rightLink)}
              href="https://github.com/Crowdaq/crowdaq-doc"
              target="_blank"
            >
              {'Document'}
            </Link>
            <Link
              variant="h6"
              underline="none"
              className={clsx(classes.rightLink, classes.linkSecondary)}
              href="https://dev2.crowdaq.com"
              target="_blank"
            >
              {'Login to DEMO'}
            </Link>
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.placeholder} />
    </div>
  );
}

export default withStyles(styles)(AppAppBar);
